import type { WorkItem } from "../../experience-shell/workflows";

/**
 * Read-time lock predicate, the client mirror of the server guard
 * `WorkItem.IsLockedAt(now)` (docs/NEXT.md — Locking → Expiry):
 *
 *   an item is *held* only while it has a holder AND `lockedUntil` is
 *   still in the future.
 *
 * An expired-but-uncleared lock (the scheduled-expiry message or the
 * backstop sweeper hasn't run yet) therefore reads as free — exactly as
 * the dispenser itself treats it — so no surface ever shows a lock the
 * server would ignore. Centralized so the queue worklist, the task card,
 * and any future lock-aware surface share one definition rather than
 * re-deriving the predicate (and its expiry edge case) independently.
 */
export function isWorkItemLockedAt(
    item: Pick<WorkItem, "lockedBy" | "lockedUntil">,
    at: Date,
): boolean {
    return (
        item.lockedBy != null &&
        item.lockedUntil != null &&
        item.lockedUntil.length > 0 &&
        new Date(item.lockedUntil).getTime() > at.getTime()
    );
}
